export enum OperatorApprovalStatusEnum {
  APPROVED = 'APPROVED',
  EXPIRED = 'EXPIRED',
  INCOMPLETE = 'INCOMPLETE',
  FAILED = 'FAILED',
  BLACKLISTED = 'BLACKLISTED',
}
